import React from 'react'
import { Draggable } from '@hello-pangea/dnd'
import { QuestionCard } from './QuestionCard'
import { Question } from '../../types/assessments'

interface SortableQuestionItemProps {
  question: Question
  index: number
  onEdit: () => void
  onDelete: () => void
}

export const SortableQuestionItem: React.FC<SortableQuestionItemProps> = ({
  question,
  index,
  onEdit,
  onDelete
}) => {
  const draggableId = String(question.id || question.uuid || `question-${question.order}`)

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            marginBottom: snapshot.isDragging ? 0 : 16
          }}
        >
          <div {...provided.dragHandleProps}>
            <QuestionCard
              question={question}
              onEdit={onEdit}
              onDelete={onDelete}
              isDragging={snapshot.isDragging}
            />
          </div>
        </div>
      )}
    </Draggable>
  )
}
